import Vue from 'vue';
import { mapMutations } from 'vuex';
import VueRouter from 'vue-router';

import VueAutosize from 'vue-autosize';

import InfiniteLoading from 'vue-infinite-loading';
// import { VueMasonryPlugin } from 'vue-masonry';
import VueClipboard from 'vue-clipboard2';
import VueMeta from 'vue-meta';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import VueYoutube from 'vue-youtube';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import SwiperClass, { Navigation, Pagination } from 'swiper';
import router from './router';
import store from './store/index';

import App from './component/Main.vue';
// import OneSignalVue from 'onesignal-vue';
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';

import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import Prism from 'prismjs';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import './sass/base.scss';
import { Buffer } from 'buffer';

// 判斷是否在原生手機環境中運行
if (Capacitor.isNativePlatform()) {
  // 這一行是可選的，因為 overlay: true 是預設行為，但明確寫出來有助於理解，它的意思是允許 WebView 延伸到狀態列下方
  StatusBar.setOverlaysWebView({ overlay: true });
  // StatusBar.setBackgroundColor({ color: '#ffffff' });
  StatusBar.setStyle({ style: Style.Dark });
  // StatusBar.setStyle({ style: Style.Light });
}

if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-multi-assign
  Vue.config.devtools = Vue.config.debug = Vue.config.productionTip = false;
} else {
  // eslint-disable-next-line no-multi-assign
  Vue.config.devtools = Vue.config.debug = Vue.config.productionTip = true;
}

SwiperClass.use([Navigation, Pagination]);
VMdPreview.use(vuepressTheme, {
  Prism,
});
Vue.use(VMdPreview);
// Vue.use(OneSignalVue);
Vue.use(VueMeta);
Vue.use(VueRouter);
Vue.use(VueClipboard);
Vue.use(VueYoutube);
Vue.use(InfiniteLoading, {
  props: {
    // spinner: 'waveDots',
    spinner: 'circles',
  },
  system: {
    throttleLimit: 50,
  },
});

Vue.use(VueAutosize);
// Vue.use(VueMasonryPlugin);
Vue.use(PerfectScrollbar);

// Google reCaptcha
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
  loaderOptions: {
    useRecaptchaNet: true, // 可選，如果 Google.com 被封鎖，使用 recaptcha.net
    autoHideBadge: true, // 可選，是否自動隱藏右下角的 reCAPTCHA 標誌（注意：若隱藏需自行顯示 reCAPTCHA 服務條款）
  },
});

// import { useShare } from '@vueuse/core'
// import i18n language
// import i18n from './i18n';
// import VueI18n from 'vue-i18n';
// Vue.use(VueI18n);

import {
  putAddUserScore,
  putAddUserPoint,
  // postOneSignalSaveSubscribe,
} from './js/restapi';

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from, next) => {
  store.dispatch('user/changeTopBarSearchBarFocus', false);
  store.dispatch('user/changeTopBarSearchBarMobileActive', false);

  if (to.name === 'feature-type') {
    store.commit('flow/INDEX_FLOW_TYPE', to.params.type);
  }
});

Vue.mixin({
  data() {
    return {
      userDevice: navigator.userAgent,
      mobileDevice: false,
      STATIC_URL: process.env.NODE_ENV === 'production' ? `${process.env.VUE_APP_GOOGLE_STORAGE_BUCKET}static/` : '/',
      SERVER_STATIC_URL: process.env.VUE_APP_GOOGLE_STORAGE_BUCKET,
      // BASE_URL: process.env.VUE_APP_GOOGLE_STORAGE_BUCKET,
      SERVER_DOMAIN: process.env.NODE_ENV === 'production' ? '' : process.env.VUE_APP_BACKEND,
      WS_HEAD: process.env.npm_config_mode === 'test' ? 'ws' : 'wss',
      WS_DOMAIN: process.env.NODE_ENV === 'production' ? window.location.host : process.env.VUE_APP_BACKEND,
      NODE_DOMAIN: process.env.NODE_ENV === 'production' ? '' : '//127.0.0.1:3000',
      LINE_LOGIN_ID: process.env.VUE_APP_LINE_ID,
      // LINE_LOGIN_DOMAIN: process.env.NODE_ENV === 'production' ? 'https://cancell.ai' : 'http://192.168.1.101:3000',
      LINE_LOGIN_DOMAIN: process.env.NODE_ENV === 'production' ? 'https://cancell.ai' : 'http://127.0.0.1:3000',

      CANCER_TYPE_FIX: ['所有癌症', '皮膚癌', '睪丸癌', '食道癌', '卵巢癌', '頭頸癌', '血癌', '鼻咽癌', '肺癌', '乳癌', '胰臟癌', '胃癌', '肝癌', '大腸癌', '直腸癌', '子宮癌', '子宮頸癌', '攝護腺癌', '膀胱癌', '淋巴癌', '原發不明頭頸癌'],
      CANCER_TYPE: ['填寫其他', '皮膚癌', '睪丸癌', '食道癌', '卵巢癌', '頭頸癌', '血癌', '鼻咽癌', '肺癌', '乳癌', '胰臟癌', '胃癌', '肝癌', '大腸癌', '直腸癌', '子宮癌', '子宮頸癌', '攝護腺癌', '膀胱癌', '淋巴癌', '原發不明頭頸癌'],
      POP_DURATION: 3000,
      cancerTreatmentList: ['無', '手術', '化療', '放療', '標靶', '免疫治療', '抗荷爾蒙', '細胞療法', '熱療'],
      cancerImmunitytherapyList: ['皮搔癢/發疹', '肌肉痛/關節痛', '頭痛/頭暈', '視野模糊', '胸痛', '血便/黑便', '心跳加速/盜汗', '全身無力/怕冷', '排尿減少/血尿', '黃疸/深色尿', '紅腫/浮腫', '水泡/口腔潰瘍'],

      chatWizardFeature: [
        {
          name: '幫我生成問題',
          value: 'chat_question',
          experimental: false,
        },
        {
          name: '幫我分析血糖血壓',
          value: 'chat_glucose_pressure',
          experimental: false,
        },
        {
          name: '推薦YouTube影片',
          value: 'chat_youtube',
          experimental: false,
        },
        {
          name: '推薦新藥試驗計劃',
          value: 'chat_trail',
          experimental: true,
        },
        // {
        //   name: '說個笑話',
        //   value: 'chat_joke',
        //   experimental: false,
        // },
        // {
        //   name: '需要正能量',
        //   value: 'chat_wisdom',
        //   experimental: false,
        // },
      ],
      // COIN_RATIO: this.subscribeVip === 'yes' ? 6 : 3,
      COIN_FREE: 1,
      COIN_VIP: 2,
      EMOJI: {
        face: [
          '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😇', '😉', '😊', '🙂', '🙃', '😋', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '🤪', '😜', '😝', '😛', '🤑', '😎', '🤓', '🧐', '🤠', '🥳', '🤗', '🤡', '😏', '😶', '😐', '😑', '😒', '🙄', '🤨', '🤔', '🤫', '🤭', '🤥', '😳', '😞', '😟', '😠', '😡', '😔', '😕', '🙁', '😬', '🥺', '😣', '😖', '😫', '😩', '🥱', '😤', '😮', '😱', '😨', '😰', '😯', '😦', '😧', '😢', '😥', '😪', '🤤', '😓', '😭', '🤩', '😵', '🥴', '😲', '🤐', '😷', '🤕', '🤒', '🤮', '🤢', '🤧', '👽', '🤖',
        ],
        action: [
          '👶', '👧', '🧒', '👩', '👨', '🧔', '🧑‍', '👩‍🦱', '👨‍🦱', '👩‍🦰‍', '👨‍🦰', '👱‍♀️', '👱', '👩‍🦳‍', '👨‍🦳', '👵', '🧓', '👳‍♀️', '👳', '👳‍♂️', '🧕', '👼', '👸', '🤴', '👩‍⚕️', '👨‍⚕️', '👨‍👨‍👧', '👪', '👐', '🤲', '🙌', '👏', '🙏', '🤝', '👍', '👎', '👊', '✊', '🤛', '🤜', '✌', '🤘', '🤟', '👌', '🤏', '👈', '👉', '👆', '👇', '☝', '✋', '🤚', '🖐', '🖖', '👋', '🤙', '💪', '🖕', '✍', '🤳', '🦶', '👄', '👂', '🦻', '👃', '👀', '🧠', '💕', '💞', '💓', '💖', '💘', '💝',
        ],
        item: [
          '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🍈', '🍒', '🍑', '🥭', '🍍', '🥝', '🍅', '🥑', '🍆', '🥒', '🥦', '🌽', '🥕', '🥗', '🚑', '🏥', '🏣', '⌚', '💻', '🖨', '📞', '📸', '💎', '💊', '💉', '💌', '🩺', '💡', '🎁', '👑', '📣', '⛔', '📆', '📂',
        ],
      },
      datePickerDayShortCut: [
        {
          text: '今天',
          onClick() {
            const d = new Date();
            return d;
          },
        },
        {
          text: '昨天',
          onClick() {
            const d = new Date();
            d.setDate(d.getDate() - 1);
            return d;
          },
        },
        {
          text: '三天前',
          onClick() {
            const d = new Date();
            d.setDate(d.getDate() - 3);
            return d;
          },
        },
        {
          text: '一週前',
          onClick() {
            const d = new Date();
            d.setDate(d.getDate() - 7);
            return d;
          },
        },
      ],
      datePickerMonthShortCut: [
        {
          text: '一個月前',
          onClick() {
            const d = new Date();
            d.setMonth(d.getMonth() - 1);
            return d;
          },
        },
        {
          text: '三個月前',
          onClick() {
            const d = new Date();
            d.setMonth(d.getMonth() - 3);
            return d;
          },
        },
        {
          text: '半年前',
          onClick() {
            const d = new Date();
            d.setMonth(d.getMonth() - 6);
            return d;
          },
        },
        {
          text: '一年前',
          onClick() {
            const d = new Date();
            d.setMonth(d.getMonth() - 12);
            return d;
          },
        },
        {
          text: '兩年前',
          onClick() {
            const d = new Date();
            d.setMonth(d.getMonth() - 24);
            return d;
          },
        },
      ],
      datePickerYearShortCut: [
        {
          text: '30年前',
          onClick() {
            const d = new Date();
            d.setYear(d.getFullYear() - 30);
            return d;
          },
        },
        {
          text: '40年前',
          onClick() {
            const d = new Date();
            d.setYear(d.getFullYear() - 40);
            return d;
          },
        },
        {
          text: '50年前',
          onClick() {
            const d = new Date();
            d.setYear(d.getFullYear() - 50);
            return d;
          },
        },
        {
          text: '60年前',
          onClick() {
            const d = new Date();
            d.setYear(d.getFullYear() - 60);
            return d;
          },
        },
        {
          text: '70年前',
          onClick() {
            const d = new Date();
            d.setYear(d.getFullYear() - 70);
            return d;
          },
        },
        {
          text: '80年前',
          onClick() {
            const d = new Date();
            d.setYear(d.getFullYear() - 80);
            return d;
          },
        },
      ],
    };
  },

  methods: {
    // Agree +10hp
    // Like +5hp
    // Bookmark +1hp
    // AddResume +500hp
    // AddBless +50hp
    // AddQa +100hp
    // AddReply +20hp
    // Follow +50hp

    // PostSideEffect +1coin

    handleUserAddHp(authId, grade) {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      const CONFIG = {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      };

      putAddUserScore('', {
        auth_id: `${authId}`,
        target: 'hp',
        grade,
      }, CONFIG)
        .then(() => {
          console.log('更新HP Score', grade);
          this.changeUserScoreStatus({ target: 'hp', grade: { hp: grade, point: '' } });
        })
        .catch((err) => { console.log('錯誤HP Score', grade, err.message); });
    },

    handleUserAddCoin(authId, event, grade) {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      const CONFIG = {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      };

      putAddUserPoint('', { event, grade }, CONFIG)
        .then((res) => {
          console.log('Point Score', event, grade);

          if (res.data === 'already exist') {
            this.changeUserScoreStatus({ target: 'point', grade: { hp: '', point: 'limit' } });
          } else if (res.data.status === 'ok') {
            this.updateUserCurrentPoint(res.data.point);
            this.changeUserScoreStatus({ target: 'point', grade: { hp: '', point: grade } });
          }
        })
        .catch((err) => { console.log('錯誤Point Score', err.message); });
    },

    transferSubscribeServiceName(service) {
      switch (service) {
        case 'vip_basic':
          return '訂閱VIP會員';
        default:
          return '無';
      }
    },

    IEVersion() {
      // const { userAgent } = navigator; // 取得浏览器的userAgent字符串
      console.log('UserAgent', this.userDevice);

      const isIE = this.userDevice.indexOf('compatible') > -1 && this.userDevice.indexOf('MSIE') > -1; // 判断是否IE<11浏览器
      const isEdge = this.userDevice.indexOf('Edge') > -1 && !isIE; // 判断是否IE的Edge浏览器
      const isIE11 = this.userDevice.indexOf('Trident') > -1 && this.userDevice.indexOf('rv:11.0') > -1;

      if (isIE) {
        const reIE = new RegExp('MSIE (\\d+\\.\\d+);');
        reIE.test(this.userDevice);
        const fIEVersion = parseFloat(RegExp.$1);
        if (fIEVersion === 7) { return 7; }
        if (fIEVersion === 8) { return 8; }
        if (fIEVersion === 9) { return 9; }
        if (fIEVersion === 10) { return 10; }
        return 6;// IE版本<=7
      }

      if (isEdge) { return 'edge'; }
      if (isIE11) { return 11; }
      return -1;
    },

    detectUserAgentDevice() {
      console.log('detectUserAgentDevice', this.userDevice, this.mobileDevice, this.$router.currentRoute);

      if (this.IEVersion() !== -1 && this.IEVersion() !== 'edge') {
        this.$router.push('upgrade').catch(() => true);
      }

      if (/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(this.userDevice) && this.rwdType !== 'desktop' && this.$router.currentRoute.name !== 'index') {
        this.mobileDevice = true;
      } else {
        this.mobileDevice = false;
      }
    },

    avatarSrcLink(url) {
      if (url.includes('http:/') || url.includes('https:/')) {
        console.log('get ThumbSrc', url);
        return url;
      }
      return `${this.SERVER_STATIC_URL}media/${url}`;
    },

    base64UrlDecode(str) {
      let s = str;
      s = s.replace(/-/g, '+').replace(/_/g, '/');
      while (s.length % 4) {
        s += '=';
      }
      return Buffer.from(s, 'base64').toString();
    },

    base64UrlEncode(str) {
      let s = Buffer.from(str).toString('base64');
      s = s.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      return s;
    },

    // async handleWpSendNotification(pushValue) {
    //   await postOneSignalSaveSubscribe('', JSON.stringify({
    //     app_id: '279f59f8-e303-48b7-9f56-5f7aefa1622c',
    //     // name: pushValue.name,
    //     contents: { en: pushValue.msg },
    //     headings: { en: pushValue.title },
    //     url: pushValue.url,
    //     filters: [
    //       {
    //         field: 'tag',
    //         key: 'type',
    //         relation: '=',
    //         value: pushValue.type,
    //       },
    //       {
    //         field: 'tag',
    //         key: 'tid',
    //         relation: '=',
    //         value: pushValue.tid,
    //       },
    //     ],
    //     // included_segments: ['Subscribed Users'],
    //     // include_external_user_ids: ['127'],
    //     // channel_for_external_user_ids: 'push',
    //   }), {
    //     headers: {
    //       // accept: 'application/json',
    //       Authorization: 'Basic os_v2_app_e6pvt6hdanelph2wl55o7ilcfsyjbngtk2oecm5eoqg7vqfpfxfkw4lrtjmt42va37sizv5r7tsmdts3cvoztk4c7ym4cbuke5dtd3i',
    //       'content-type': 'application/json',
    //     },
    //   }).then((res) => {
    //     console.log('OneSignal Push', res);
    //   }).catch((err) => {
    //     console.log('OneSignal Push', err);
    //   });
    // },

    ...mapMutations({
      changeUserScoreStatus: 'user/TOPBAR_USER_SCORE',
      updateUserCurrentPoint: 'user/TOPBAR_USER_UPDATE_POINT',
    }),
  },
});

const vm = new Vue({
  store,
  router,
  // i18n,
  render: (h) => h(App),
  // beforeMount() {
  //   this.$OneSignal.init({
  //     appId: 'fab7d6fe-205f-4dab-b6de-9c56b2b8e2b7',
  //   });
  // },
}).$mount('#cancell');

(() => vm)();
